export const VALID_HUB_ATTRIBUTES = [
  'address',
  'birthdate',
  'email',
  'email_verified',
  'family_name',
  'gender',
  'given_name',
  'name',
  'nickname',
  'phone_number',
  'phone_number_verified',
  'picture',
  'preferred_username',
  'profile',
  'zoneinfo',
  'updated_at',
  'website'
];

export const MANDATORY_HUB_ATTRIBUTES = [
  'email',
  'family_name',
  'given_name',
  'preferred_username'
];

export const validateAttributeMapping = (v, sourceType = 'saml', hint = '') => {
  if (!v) return true;

  if (!v.includes(':'))
    return `Each mapping must be in format hub-attribute:${sourceType}-attribute. ${hint}`;

  const colonIndex = v.indexOf(':');
  const hubAttr = v.substring(0, colonIndex);
  const idpAttr = v.substring(colonIndex + 1);

  if (!hubAttr || !idpAttr)
    return `Each mapping must be in format hub-attribute:${sourceType}-attribute. ${hint}`;

  if (!VALID_HUB_ATTRIBUTES.includes(hubAttr)) {
    return `"${hubAttr}" is not a valid hub attribute`;
  }

  return true;
};

export const validateAttributeMappings = (v, sourceType = 'saml', hint = '') => {
  const raw = v || '';

  if (!raw.trim()) return `${hint}`;

  const mappings = raw
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean);

  if (mappings.length === 0) return `${hint}`;

  let errorMessage = null;
  mappings.some((mapping) => {
    const result = validateAttributeMapping(mapping, sourceType, hint);
    if (result !== true) {
      errorMessage = result;
      return true;
    }
    return false;
  });
  if (errorMessage) return errorMessage;

  const mappedHubAttrs = mappings.map((m) => m.substring(0, m.indexOf(':')));
  const missing = MANDATORY_HUB_ATTRIBUTES.filter((a) => !mappedHubAttrs.includes(a));
  if (missing.length > 0) {
    return `Missing mandatory hub attribute(s): ${missing.join(', ')}. ${hint}`;
  }
  const uniqueMappings = [...new Set(mappedHubAttrs)];

  // ensure no duplicates in each attribute mapping
  if (uniqueMappings.length !== mappedHubAttrs.length) {
    return `Duplicate attribute detected. ${hint}`;
  }
  return true;
};

export const formatAttributeMappings = (attributeMappings) => {
  if (!attributeMappings) return attributeMappings;

  // to ensure no || or trailing |
  let formattedAttributeMappings = attributeMappings?.replace(/\|+$/, '');
  // remove all empty string between |
  formattedAttributeMappings = formattedAttributeMappings?.split('|').filter(Boolean).join('|');
  return formattedAttributeMappings;
};
